<template>
  <div class="conteudoInterno" id="atividades">
    <div class="boxSeta">
      <div class="setaScrollstatic" style="" :class="{
        setaScroll: setaScrollState,
      }">
        <button>
          <span><i class="bottom"></i></span>
        </button>
      </div>
    </div>
    <header class="headerSec">
      <h2>Main activities</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked">
          <span><i class="left"></i></span>
        </button>
        <button @click="goNext()" :disabled="clicked">
          <span :class="{ hideSeta: setaRightState }"><i class="right"></i></span>
        </button>
      </div>
      <!-- <span></span> -->
    </header>
    <div class="conteudoInternoBox">
      <section class="sectionRow">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcPurpleBack"></span>
        </div>
      </section>
      <section class="sectionRow top65">
        <div class="col23ponto5"></div>
        <div class="col66">
          <h4 class="h4Destaque">
            UBC Award for <span class="ubcPurple sanukBlack">Zeca Pagodinho</span>
          </h4>

          <p class="top32">
            The Brazilian Songwriter Award, in its ninth edition, honored a samba artist for the first time. At Casa UBC in Rio de Janeiro, twelve songs from Zeca Pagodinho’s repertoire were performed by leading names in Brazilian music — from Gilberto Gil to João Gomes — bringing generations together in a night that turned the venue into an authentic samba party. <a href="https://www.youtube.com/watch?v=1eIIEXdT5PE" target="_blank"
              rel="noopener noreferrer nofollow"> <span>Watch + (in Portuguese)</span></a>
          </p>

          <div v-show="!value1" class="button top32" v-on:click="value1 = !value1" :disabled="clicked">
            <button class="sanukBold">

              <!-- <div class="leiaMais"></div> -->
            </button>
          </div>
          <div v-show="value1" class="button top32" v-on:click="value1 = !value1" :disabled="clicked">
            <button class="sanukBold">
              <span>Close </span>
              <div class="fechar"></div>
            </button>
          </div>

          <h4 class="h4Destaque top50">
            <span class="ubcPurple sanukBlack">“Por Elas Que Fazem a Música”</span> Report + <span class="ubcPurple sanukBlack">SongCamp with SPA</span>
          </h4>
          <p class="top32">
            UBC has been monitoring women’s participation in Brazilian music for the past eight years, and each edition of
            Por Elas Que Fazem a Música (By The Women Who Make The Music) has highlighted both progress and challenges.
            Over this period, the number of female members has grown by 210%.
          </p>
          <p class="">
            As a further development, the second season of SongCamp brought together Brazilian and Portuguese songwriters
            in an unprecedented partnership with the Portuguese Society of Authors (SPA), resulting in “Flor de Asfalto”,
            a song about journeys, healing, and resilience, featured in a documentary series on UBC’s YouTube channel.
            <a href="https://www.canva.com/design/DAGcRgCB-Mc/FYAuAOG-3V5axkVRRfpR8A/view?utm_content=DAGcRgCB-Mc&%20(URL%20pode%20ser%20maliciosa);utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h08053e7cf9#1" target="_blank" rel="noopener noreferrer nofollow"><span>Read more + (in Portuguese)</span></a>
             &nbsp; 
            <a href="https://www.youtube.com/watch?v=EhW_kNvpKEE&list=PLK2i8iPUlTrImgDRM_7MoBjASbN7TKuCd" target="_blank" rel="noopener noreferrer nofollow"><span>Watch + (in Portuguese)</span></a>
          </p>

          <div v-show="!value2" class="button top32" :disabled="clicked">
            <button class="sanukBold"></button>
          </div>
          <div v-show="value2" class="button top32" :disabled="clicked">
            <button class="sanukBold">
              <span>Close </span>
              <div class="fechar"></div>
            </button>
          </div>

          <h4 class="h4Destaque">
            UBC Traditions for <span class="ubcPurple sanukBlack">Rosa Passos</span>
          </h4>
          <p class="top32">
            In tribute to Rosa Passos, UBC celebrated the Brazilian singer, composer, and guitarist from Bahia, who
            achieved international acclaim before receiving due recognition in her home country. At Casa UBC, she
            performed the show “Suíte Brasileira” alongside Paula Lima, Fernanda Takai, and Vanessa Moreno, in an
            emotional night of live music that marked the 5th edition of the Traditions Trophy.
            <a href="https://www.youtube.com/watch?v=pQ5sg9-KFCk&list=PLK2i8iPUlTrJXb5xu1WpLMDvt1H72yIKs" target="_blank" rel="noopener noreferrer nofollow"><span>Check it out + (in Portuguese)</span></a>
          </p>

          <div v-show="!value3" class="button top32" :disabled="clicked">
            <button class="sanukBold"></button>
          </div>
          <div v-show="value3" class="button top32" v-on:click="value3 = !value3" :disabled="clicked">
            <button class="sanukBold"><span>Close </span>
              <div class="fechar"></div>
            </button>
          </div>

          <h4 class="h4Destaque">
            2nd Season of <span class="ubcPurple sanukBlack">“Palavra de Autor”</span>
          </h4>
          <p class="top32">
            UBC’s original webcast hosted by Celso Fonseca returned with 13 new episodes, recorded at Sonastério studio in
            Minas Gerais. Celebrating the richness of music from Minas Gerais and Brazil, the season featured artists such
            as Beto Guedes, Mauricio Tizumba, Paulinho Pedra Azul, and Fernanda Takai, in relaxed conversations revealing the
            stories and emotions behind iconic songs.
            <a href="https://www.youtube.com/watch?v=qAl_L1zfrFI&list=PLK2i8iPUlTrLgwu0gv-Z2OFkORwAfNmRQ" target="_blank" rel="noopener noreferrer nofollow"><span>Watch + (in Portuguese)</span></a>
          </p>

          <div v-show="!value4" class="button top32" :disabled="clicked">
            <button class="sanukBold"></button>
          </div>
          <div v-show="value4" class="button top32" v-on:click="value4 = !value4" :disabled="clicked">
            <button class="sanukBold"><span>Close </span>
              <div class="fechar"></div>
            </button>
          </div>

          <h4 class="h4Destaque">
            UBC Medal for <span class="ubcPurple sanukBlack">Luiz Caldas</span>
          </h4>
          <p class="top32">
            On the 40th anniversary of the album “Magia” and of axé music, UBC awarded Luiz Caldas the UBC Medal in
            Salvador. The Bahian singer and composer was honored in a special evening featuring Carlinhos Brown, Saulo
            Fernandes, and other major artists, celebrating his creativity and the lasting impact of his work on Brazilian
            music.
            <a href="https://www.ubc.org.br/publicacoes/noticias/luiz-caldas-recebe-medalha-ubc-em-noite-de-estrelas-e-musica" target="_blank" rel="noopener noreferrer nofollow"><span>Read more + (in Portuguese)</span></a>
          </p>

          <div v-show="!value5" class="button top32" :disabled="clicked">
            <button class="sanukBold"></button>
          </div>
          <div v-show="value5" class="button top32" v-on:click="value5 = !value5" :disabled="clicked">
            <button class="sanukBold"><span>Close </span>
              <div class="fechar"></div>
            </button>
          </div>

          <h4 class="h4Destaque">
            <span class="ubcPurple sanukBlack">New UBC Website</span> and Virtual Assistant <span class="ubcPurple sanukBlack">Chiquinha</span>
          </h4>
          <p class="top32">
            More modern, faster, and accessible, UBC has launched a fully redesigned website, available in three languages
            and featuring new accessibility tools. The main innovation is Chiquinha, a virtual assistant inspired by
            Chiquinha Gonzaga, who provides real-time guidance on membership, work registration, payments, and much more.
            <a href="https://www.ubc.org.br/publicacoes/noticias/nova-cara-mais-agilidade-e-uma-ajudante-virtual-conheca-o-novo-site-da-ubc" target="_blank" rel="noopener noreferrer nofollow"><span>Learn more + (in Portuguese)</span></a>
          </p>

          <div v-show="!value6" class="button top32" :disabled="clicked">
            <button class="sanukBold"></button>
          </div>
          <div v-show="value6" class="button top32" v-on:click="value6 = !value6" :disabled="clicked">
            <button class="sanukBold"><span>Close </span>
              <div class="fechar"></div>
            </button>
          </div>




        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ShareFunctions } from "../assets/js/functions.js";

export default {
  name: "AtividadesPrincipais",
  props: ["clicked"],

  data() {
    return {
      setaScrollState: false,
      setaRightState: false,
      value1: false,
      value2: false,
      value3: false,
      value4: false,
      value5: false,
      value6: false,
    };
  },
  mounted() {
    const conteudo = document.querySelector("#atividades");
    conteudo.addEventListener("scroll", ShareFunctions.headerScroll);
  },
  created() {
    this.hideSetaFunc();
  },
  methods: {
    hideSetaFunc: function () {
      let route = this.$route.path;
      if (route === "/MainActivities") {
        this.setaRightState = true
      } else {
        this.setaRightState = false
      }
    },
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p a {
  color: #8781D1;
  font-family: 'sanuk-bold';
}

.button {
  width: 100%;
  border-bottom: 1px solid #8781d1;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 32px;
}

button {
  color: #8781d1;
  cursor: pointer;
  padding-bottom: 4px;
  display: flex;
}

.hidden {
  opacity: 1;
  max-height: auto;
  overflow: hidden;
  animation: open 0.75s ease-in;
}

@keyframes open {
  0% {
    max-height: 0;
    opacity: 0;
  }

  100% {
    max-height: 2000px;
    opacity: 1;
  }
}

.leiaMais::before,
.leiaMais::after,
.fechar::before,
.fechar::after {
  content: "";
  position: absolute;
  background-color: #8781d1;
  transition: transform 0.25s ease-out;
}

.leiaMais {
  position: relative;
  width: 15px;
  height: 15px;
  margin-left: 10px;
}

.leiaMais::before {
  top: 0;
  left: Calc(50% - 1.5px);
  width: 3px;
  height: 100%;
}

.leiaMais::after {
  top: 50%;
  left: 0;
  width: 100%;
  height: 3px;
  margin-top: -1.5px;
}

.fechar {
  position: relative;
  width: 15px;
  height: 15px;
  margin-left: 10px;
}

.fechar::before {
  top: 0;
  left: Calc(50% - 1.5px);
  width: 3px;
  height: 100%;
  margin-left: -1.5px;
  transform: rotate(90deg);
}

.fechar::after {
  top: 50%;
  left: 0;
  width: 100%;
  height: 3px;
  margin-top: -1.5px;
}
</style>
